import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export const fetchreorderlevel = createAsyncThunk(
  "master/fetchOrder",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters?.length) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null)
            return;

          // 🗓 Handle date-range filters (object with from_date / to_date)
          if (typeof filterValue === "object" && filterValue !== null) {
            const { from_date, to_date } = filterValue;

            if (
              from_date &&
              (filterField === "created_at" || filterField === "updated_at" || filterField === "order_date")
            ) {
              params.append(`${filterField}_from`, from_date);
            }

            if (
              to_date &&
              (filterField === "created_at" || filterField === "updated_at" || filterField === "order_date")
            ) {
              params.append(`${filterField}_to`, to_date);
            }
          }

          // 🔤 Handle simple (non-object) filters
          else {
            params.append(filterField, String(filterValue));
          }
        }
      );
    }

    const response: any = await Axios.get(
      `${api?.Inventory.Reorderlevel.ItemWise.listing}?${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportRecordLevelItemWise = async ({
  page,
  pageSize,
  sort,
  order,
  search,
  filters,
}: {
  page?: number;
  pageSize?: number;
  sort?: string;
  order?: "asc" | "desc" | "";
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "csv");


  if (search) params.append("search", search);

  // Handle sorting
  if (sort) {
    const orderingVal = order === "desc" ? `-${sort}` : sort;
    params.append("ordering", orderingVal);
  }

  // ✅ handle dynamic filters
  filters?.forEach(({ filterField, filterValue }: any) => {
    if (filterValue === undefined || filterValue === null || filterValue === "") return;

    // Handle date range filters (object with from_date / to_date)
    if (typeof filterValue === "object" && filterValue !== null) {
      const { from_date, to_date } = filterValue;

      if (from_date || to_date) {
        // Handle date fields: inward_date, created_at, updated_at
        if (filterField === "inward_date") {
          if (from_date) params.append("inward_date_from", from_date);
          if (to_date) params.append("inward_date_to", to_date);
        } else if (filterField === "created_at") {
          if (from_date) params.append("created_at_from", from_date);
          if (to_date) params.append("created_at_to", to_date);
        } else if (filterField === "updated_at") {
          if (from_date) params.append("updated_at_from", from_date);
          if (to_date) params.append("updated_at_to", to_date);
        }
        return;
      }

      // Handle other object filters
      Object.entries(filterValue).forEach(([key, val]) => {
        if (val !== undefined && val !== null && val !== "") {
          params.append(key, String(val));
        }
      });
    } else {
      // Handle simple string/number filters
      params.append(filterField, String(filterValue));
    }
  });

  const res = await Axios.get(
    `${api?.Inventory?.Reorderlevel?.ItemWise?.listing}?${params.toString()}`,
    { responseType: "blob" }
  );

  return {
    blob: res.data,
    filename:
      res.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "RecordLevelWarehouseWise.csv",
  };
};